import BaseService from './BaseService'
import { httpClient } from '@/api/httpClient'
import UrlService from './UrlService'

export default class PoliciesService extends BaseService {
  static async create (data) {
    return httpClient.post('/protected/policies', data)
  }

  static async update (id, data) {
    return httpClient.put(`/protected/policies/${id}`, data)
  }

  static async getPolicies (payload, payloadQ) {
    const filters = new URLSearchParams()
    filters.set('page', payload.page)
    filters.set('per_page', payload.per_page)

    const q = UrlService.getFiltersQuery(payloadQ)

    const data = await httpClient.get(`/protected/policies?${filters}&${q}`)

    return data
  }
}
